/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApImprovement
 */
export interface ApImprovement {
    /**
     * 比較対象の計算結果区分
     * @type {string}
     * @memberof ApImprovement
     */
    vsClass?: string;
    /**
     * 効果
     * @type {number}
     * @memberof ApImprovement
     */
    improvement?: number;
}

/**
 * Check if a given object implements the ApImprovement interface.
 */
export function instanceOfApImprovement(value: object): value is ApImprovement {
    return true;
}

export function ApImprovementFromJSON(json: any): ApImprovement {
    return ApImprovementFromJSONTyped(json, false);
}

export function ApImprovementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApImprovement {
    if (json == null) {
        return json;
    }
    return {
        
        'vsClass': json['vsClass'] == null ? undefined : json['vsClass'],
        'improvement': json['improvement'] == null ? undefined : json['improvement'],
    };
}

export function ApImprovementToJSON(value?: ApImprovement | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'vsClass': value['vsClass'],
        'improvement': value['improvement'],
    };
}

